export default __webpack_public_path__ + "static/media/Group9168.7428e9a5.svg";